import React, { useState } from "react";
import { Calendar } from "primereact/calendar";

const DateRangePicker = ({
  dates,
  setDates,
  range = "range", // single, multiple, range
  placeholder = "Date",
  showButtonBar = true,
}) => {
  const hasValue = Array.isArray(dates) ? dates?.some((d) => d) : !!dates;

  return (
    <div className={`date_range_picker ${hasValue ? "has-value" : ""}`}>
      <Calendar
        value={dates}
        onChange={(e) => setDates(e.value)}
        selectionMode={range}
        readOnlyInput
        hideOnRangeSelection
        showIcon
        placeholder={placeholder}
        showButtonBar={showButtonBar}
      />
    </div>
  );
};

export default DateRangePicker;
